<template>
    <AppModal ref="modal" :title="$t('labels.table_filters')" @on-hide="hide">
        <div class="modal-body">
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th width="50%">{{ $t('labels.field') }}</th>
                            <th width="50%">{{ $t('labels.action') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="field in fields">
                            <tr>
                                <td>{{ field.label }}</td>
                                <td>
                                    <AppSelect
                                        :options="getActionOptionsByField(field.key)"
                                        :model-value="field.selectedAction?.key"
                                        :selected-value="field.selectedAction?.label"
                                        @update:model-value="field.selectedAction = $event"
                                        option-key="key"
                                        option-value="label"
                                        can-be-empty
                                    />
                                </td>
                            </tr>
                            <tr v-if="field.selectedAction && ['category_uuids'].includes(field.key)">
                                <td colspan="2">
                                    <MultiAutoComplete
                                        :model-value="field.value ?? []"
                                        @update:model-value="field.value = $event"
                                        :url="`/projects/${$route.params.projectUuid}/pim/channels/${integrationSourceUuid}/categories`"
                                    />
                                </td>
                            </tr>
                            <tr v-if="field.selectedAction && ['export_enabled'].includes(field.key)">
                                <td colspan="2">
                                    <AppCheckbox
                                        v-model="field.value"
                                    />
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="emitFilters">
                {{ $t('buttons.accept') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../components/new/modal/AppModal.vue';
import AppSelect from '../../../../components/new/form/select/AppSelect.vue';
import MultiAutoComplete from '../../../../components/new/form/autocomplete/MultiAutoComplete.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import AppCheckbox from '../../../../components/new/form/checkbox/AppCheckbox.vue';

export default {
    name: 'CompareIntegrationsFilterModal',
    components: {
        AppModal, AppSelect, MultiAutoComplete, AppButton, AppCheckbox
    },
    props: {
        integrationSourceUuid: {
            type: String,
            required: false
        }
    },
    emits: ['apply-filters'],
    data() {
        return {
            fields: [
                { key: 'has_match', label: this.$t('labels.conformity'), selectedAction: null, value: null },
                { key: 'category_uuids', label: this.$t('labels.categories'), selectedAction: null, value: null },
                { key: 'has_internal_product', label: this.$t('table.titles.internal_id'), selectedAction: null, value: null },
                { key: 'export_enabled', label: this.$t('labels.exportEnabled'), selectedAction: null, value: null },
                { key: 'availability', label: this.$t('labels.availability'), selectedAction: null, value: null },
            ]
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        clear() {
            this.fields.forEach(field => {
                field.selectedAction = null;
                field.value = null;
            });
            this.$emit('apply-filters', {}, 0);
        },
        hide() {
            this.$refs.modal.hide();
        },
        getActionOptionsByField(field) {
            let options = [];

            if (field === 'has_match') {
                options = [
                    { key: 'finned', label: this.$t('labels.finned') },
                    { key: 'not_finned', label: this.$t('labels.not_finned') },
                ];
            }

            if (field === 'category_uuids') {
                options = [
                    { key: 'correlate', label: this.$t('labels.correlate') },
                ]
            }

            if (field === 'has_internal_product') {
                options = [
                    { key: 'present', label: this.$t('labels.present') },
                    { key: 'missing', label: this.$t('labels.missing') },
                ];
            }

            if (field === 'export_enabled') {
                options = [
                    { key: 'correlate', label: this.$t('labels.correlate') },
                ]
            }

            if (field === 'availability') {
                options = [
                    { key: 'present', label: this.$t('labels.present') },
                    { key: 'missing', label: this.$t('labels.missing') },
                ];
            }

            return options;
        },
        emitFilters() {
            let filters = {};

            for (let field of this.fields) {
                if (field.selectedAction) {
                    if (field.key === 'has_match') {
                        if (field.selectedAction.key === 'finned') {
                            filters['has_match'] = 1;
                        } else if (field.selectedAction.key === 'not_finned') {
                            filters['has_match'] = 0;
                        }
                    }
                    if (field.key === 'category_uuids' && field.value.length > 0) {
                        filters['category_uuids'] = field.value.map(item => item.uuid);
                    }
                    if (field.key === 'has_internal_product') {
                        if (field.selectedAction.key === 'present') {
                            filters['has_internal_product'] = 1;
                        } else if (field.selectedAction.key === 'missing') {
                            filters['has_internal_product'] = 0;
                        }
                    }
                    if (field.key === 'export_enabled') {
                        filters['export_enabled'] = field.value !== null ? Number(field.value) : 0;
                    }
                    if (field.key === 'availability') {
                        if (field.selectedAction.key === 'present') {
                            filters['availability'] = 1;
                        } else if (field.selectedAction.key === 'missing') {
                            filters['availability'] = 0;
                        }
                    }
                }
            }

            this.$emit('apply-filters', filters, this.fields.filter(f => f.selectedAction !== null).length);
            this.hide();
        }
    }
};
</script>